import $ from 'jquery';

export const topOffset = () => {
  return $('#pivot-table-timeline-container').offset().top;
};

export const getScaleHeight = (viewOnly, dashboard, fontSize) => {
  // Bigger fonts are taller. Doubled to account for the major and minor interval rows
  const fontSizeAdjustment = (fontSize - 12) * 2; // Scale-row-height calculation

  if (dashboard) {
    return 27 + fontSizeAdjustment;
  } else if (viewOnly) {
    return 45 + fontSizeAdjustment;
  } else {
    return 95 + fontSizeAdjustment;
  }
};

export const getScaleBarHeight = viewOnly => {
  return viewOnly ? 0 : 50;
};

export const contentWidth = (resourceTree, fontSize, container = null) => {
  if (!container) {
    container = $('body');
  }
  return $(container).width() - getSideBarWidth(resourceTree, fontSize);
};

export const getSideBarWidth = (resourceTree, fontSize) => {
  const columnWidth = (fontSize - 12) * 12 + 150; // Timeline-column-width calculation
  return columnWidth * resourceTree.depth();
};

let scrollbarWidth;
export const getScrollbarWidth = () => {
  if (scrollbarWidth === undefined) {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const widthNoScroll = outer.offsetWidth;

    // force scrollbars
    outer.style.overflow = 'scroll';

    // add innerdiv
    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);
    const widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode && outer.parentNode.removeChild(outer);
    scrollbarWidth = widthNoScroll - widthWithScroll;
  }

  return scrollbarWidth;
};
